import Spacing from "@able/react/dist/Spacing";
import TextStyle from "@able/react/dist/TextStyle";
import PrimaryMessageContainer from "../assets/images/primary-messageContainer.svg?url";
import ErrorMessageContainer from "../assets/images/error-messageContainer.svg?url";
import MessageTemplate, { MessageTemplateProps } from "./MessageTemplate";
import { AbleCommonProps } from "../Types";

export type messageTemplateType = {
    primaryButtonLabel: string;
    secondaryButtonLabel: string;
} & Omit<MessageTemplateProps, 'content' | 'primaryButton' | 'secondaryButton' | 'imageSrc'> & AbleCommonProps ;

export const MessageTemplatePrimary = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">For now, we’re sending you to Telstra Order Express for ordering plans, devices, IoT devices and accessories.</TextStyle>
        <Spacing top="spacing3x" />
        <TextStyle element="p">Soon, we’ll bring Telstra Order Express  into Telstra Connect for centralised ordering.</TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={PrimaryMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
            icon: "ArrowLeft",
        }}
    />
}


export const MessageTemplate400 = (props: messageTemplateType) => {

    const content = <>
        <TextStyle element="p">Submit a support enquiry if there&rsquo;s still a problem.</TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate401 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">You&rsquo;ll need a billing account number or Telstra service ID  to complete the request.</TextStyle>
        <Spacing top="spacing3x" />
        <TextStyle element="p">All requests need validation and access is not instant.</TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate403 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            You&rsquo;ll need a billing account number or Telstra service ID  to complete the request.
        </TextStyle>
        <Spacing top="spacing3x" />
        <TextStyle element="p">
            All requests need validation and access is not instant.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate404 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if you think this is an error or go back to home.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
            icon: "ArrowLeft",
        }}
    />
}

export const MessageTemplate405 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if there&rsquo;s still a problem.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate406 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if there&rsquo;s still a problem.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate407 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if you think you should have access to this page.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
            icon: "ArrowLeft",
        }}
    />
}

export const MessageTemplate408 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if there&rsquo;s still a problem.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate409 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if there&rsquo;s still a problem.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
        }}
    />
}

export const MessageTemplate500 = (props: messageTemplateType) => {
    const content = <>
        <TextStyle element="p">
            Submit a support enquiry if there&rsquo;s still a problem.
        </TextStyle>
    </>
    return <MessageTemplate {...props}
        imageSrc={ErrorMessageContainer}
        content={content}
        primaryButton={{
            variant: "HighEmphasis",
            label: props.primaryButtonLabel,
            element: "button",
        }}
        secondaryButton={{
            developmentUrl: props.developmentUrl,
            variant: "LowEmphasis",
            label: props.secondaryButtonLabel,
            element: "button",
        }}
    />
}